<template>
  <button
    :class="[
      'rounded-button',
      `rounded-button--${size}`
    ]"
    @click="buttonAction"
  >
    <span class="rounded-button__bg" />
    <p>{{ content }}</p>
  </button>
</template>

<script>
import audio from '@/scripts/audio';

export default {
  name: 'ButtonRounded',

  props: {
    action: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'small',
    },
    skin: {
      type: String,
      required: false,
      default: 'yellow',
    },
  },

  methods: {
    buttonAction() {
      // audio.play('click');

      switch (true) {
        case this.action === 'intro':
          this.$store.commit('SET_MODE', 'intro');
          break;

        case this.action === 'pgSelection':
          audio.play('background');
          this.$store.commit('SET_MODE', 'pgSelection');
          break;

        case this.action === 'startTutorial':
          this.$store.commit('SET_SKIN', this.skin.toUpperCase());
          this.$eventHub.$emit('resume');
          this.$store.commit('SET_MODE', 'tutorial');
          this.$eventHub.$emit('tutorial');
          break;

        case this.action === 'play':
          this.$store.commit('SET_SKIN', this.skin.toUpperCase());
          this.$eventHub.$emit('resume');
          this.$eventHub.$emit('tutorial');
          this.$store.commit('SET_MODE', 'playing');
          audio.play('countdown');
          setTimeout(() => this.$game.startPlaying(), 3000);
          this.$sendEvent('Start', 'start');
          break;

        case this.action === 'resumeGame':
          this.$eventHub.$emit('resume');
          break;

        case this.action === 'playAgain':
          this.$store.commit('SET_MODE', 'playing');
          this.$eventHub.$emit('replay');
          this.$sendEvent('Start', 'start_replay');
          break;

        default:
          console.log('NO_ACTION_FOUND');
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rounded-button {
  position: relative;
  min-width: 150px;
  min-height: 50px;
  padding: 12px 30px;

  background-color: transparent;

  color: $color-white;
  text-align: center;
  font-weight: 800;
  letter-spacing: 1.5px;
  @extend %font-button;
  line-height: 1;

  pointer-events: auto;
  cursor: pointer;

  &.rounded-button--big {
    width: 180px;
  }

  &__bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: $color-ui;
    border-radius: 100px;
    box-shadow: $button-shadow;

    @extend %grain;
  }

  p {
    display: block;
    position: relative;
    margin-top: 2px;
    text-transform: uppercase;
  }

  @include mq(ipadP, $and: $is-not-touch-device) {
    .rounded-button,
    &.rounded-button--big {
      width: 240px;
      height: 60px;
      line-height: 60px;
    }
  }

  @include mq($and: $is-not-touch-device) {
    &__bg {
      transition: transform 0.5s $flap;
    }
    &:hover &__bg {
      transform: scale(1.1);
    }
  }
}
</style>
